import axios from "axios";
import qs from "qs";
import { URL, NOW, TOKEN, YEAR_NOW, MONTH } from "../utils/const";
import { groupByRegId } from "../utils/groupBy";

export const ctaCorriente = async (imponibleId, tipo) => {
  try {
    const ctaCorriente = await axios({
      method: "post",
      url: URL + "cuenta_corriente",
      data: qs.stringify({
        TOKEN: TOKEN,
        IMPONIBLE_ID: imponibleId,
        FECHA_ACTUALIZACION: NOW,
      }),
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    });

    if (ctaCorriente.data.error) return ctaCorriente.data;

    const impFilter = ctaCorriente.data.items.filter((el) => {
      let mes;
      let fecha;
      let sobreFecha;
      if (tipo !== "PPG") {
        fecha = el.reg_id.substring(0, 7);
        sobreFecha = obtener_año();
        //console.log("fecha y year_now",[fecha, sobreFecha]);
        return (
          el.es_deuda === "S" && el.es_transac === "S" && fecha >= sobreFecha
        );
      }
      if (el.reg_id.includes(":")) {
        fecha = el.reg_id.split(":", 7)[1];
        mes = MONTH - 6;
        sobreFecha = YEAR_NOW + "-0" + mes;
        //console.log("fecha y year_now",[fecha, sobreFecha]);
        return (
          el.es_deuda === "S" && el.es_transac === "S" && fecha >= sobreFecha
        );
      }

      fecha = el.fecha.substring(0, 7);
      mes = MONTH - 6;
      sobreFecha = YEAR_NOW + "-0" + mes;
      //console.log("fecha y year_now",[fecha, sobreFecha]);
      return (
        el.es_deuda === "S" &&
        el.actualizado !== el.saldo &&
        fecha >= sobreFecha
      );
    });

    if (tipo === "INM") {

      const newFilter = impFilter.filter(imp => {
        if (imp.fecha.startsWith('2026')) {
          return imp
        }
      })
      return groupByRegId(newFilter);
    } else {
      return impFilter;
    }
  } catch (error) {
    return error;
  }
};

//Devuelve la fecha de hace 5 años atras con respecto a la actual
function obtener_año() {
  let year = YEAR_NOW;
  let respuesta = "";
  let month = MONTH;
  year = parseInt(year) - 5;
  if (month < 10) {
    respuesta = year + "-0" + month;
  } else {
    respuesta = year + "-" + month;
  }
  return respuesta;
}

//Se utiliza para obtener la fecha desde el mes actual, 6 meses para atras
/* function obtener_fecha() {
  let year = YEAR_NOW;
  let respuesta = "";
  let month = MONTH;

  if (month <= 6) {
    year = parseInt(year) - 1;
    month = parseInt(month) + 6;
  } else {
    month = parseInt(month) - 6;
  }

  if (month < 10) {
    respuesta = year + "-0" + month;
  } else {
    respuesta = year + "-" + month;
  }

  return respuesta;
} */
